export default __webpack_public_path__ + "static/media/mp3icon.5eee7c8c.png";